import { render, staticRenderFns } from "./LunchReports.vue?vue&type=template&id=0c3ef938&"
import script from "./LunchReports.vue?vue&type=script&lang=js&"
export * from "./LunchReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports